/*
    Creation Time: 2022 - June - 6
    Created by:  (hamidrezakk)
    Maintainers:
       1.  HamidrezaKK (hamidrezakks@gmail.com)
    Auditor: HamidrezaKK
    Copyright Qlub_ 2022
*/

export const parseJSON = (data: any) => {
    try {
        return typeof data === 'string' ? JSON.parse(data) : data;
    } catch {
        return undefined;
    }
};
